module.exports = __webpack_public_path__ + "static/img/Charlie_Dixon_mobile.6ef2c8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Charlie_Dixon_mobile.jpg
// module id = g8wF
// module chunks = 0